import React from 'react';
import './Treeosk.css';
import ImageZoom from '../../commons/ImageZoom';

const Treeosk = () => {
  return (
    <div className="portfolio">
      <header className="header">
        <h1>Maintenance de créateur d'interface pour Treeosk</h1>
        <p>Treeosk est une solution numérique innovante visant à transformer l'expérience client en magasin grâce à des supports digitaux interactifs. Elle permet aux entreprises de présenter leurs produits et services de manière engageante, augmentant ainsi l'interaction avec les clients.</p>
      </header>

      <section className="project-gallery">
        <div className="project">
          <ImageZoom alt={''} src={'./assets/treeosk-admin.png'}/>
          <h3 className='mt-3'>Ajout de composants</h3>
          <p>Ajout de nouveaux composants et modules pour compléter l'offre des catalogues de Treeosk.</p>
        </div>
        <div className="project">
          <ImageZoom alt={''} src={'./assets/treeosk-connect.png'}/>
          <h3 className='mt-3'>Ajout d'un websocket</h3>
          <p>Afin de simplifier et limiter les déplacements de l'équipe des techniciens, ajout d'une nouvelle fonctionnalité pour permettre à l'équipe de changer les interfaces des écrans à distance.</p>
        </div>
      </section>

      <section className="skills">
        <h2>Technologies utilisées</h2>
        <ul>
          <li>JavaScript</li>
          <li>React</li>
          <li>CSS / SCSS</li>
          <li>Node.js</li>
          <li>Express</li>
          <li>Graphql</li>
          <li>Postgresql</li>
        </ul>
      </section>

      <footer className="portfolio-footer">
          <a href="mailto:julien.j.1999@hotmail.com">Contactez-moi: julien.j.1999@hotmail.com</a>
    </footer>
    </div>
  );
};

export default Treeosk;
